import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../constants/common'
import { getQaSelector } from '../../../../../utils/common'
import Button, { BUTTON_HEIGHT_24, ButtonArrow } from '../../../../Button'

import {
  QA_NAME_DELETE_INSURANCE_ITEM_BTN,
  QA_NAME_INSURANCE_ITEM_BTN,
} from './AccordionControlButtons.constants'
import { getQaNameInsuranceButton } from './AccordionControlButtons.utils'

import * as styles from './AccordionControlButtons.module.css'

import Delete from '../../../../../icons/delete.svg'

function AccordionControlButtons({
  Container = 'div',
  index,
  isOpen,
  onRemove,
  onToggleVisibility,
}) {
  const { t } = useTranslation()

  const qaProps = getQaSelector({
    value: getQaNameInsuranceButton(QA_NAME_INSURANCE_ITEM_BTN, index),
  })

  return (
    <Container
      {...qaProps}
      className={styles.button}
      onClick={onToggleVisibility}
    >
      <ButtonArrow
        height={BUTTON_HEIGHT_24}
        isOpen={isOpen}
        text={`${t('Building.InhabitantBtnKey')} ${index + 1}`}
      />
      <Button.Outlined
        isGrey
        beforeIconProps={{
          Icon: Delete,
        }}
        className={styles.deleteButton}
        height={BUTTON_HEIGHT_24}
        qaName={getQaNameInsuranceButton(
          QA_NAME_DELETE_INSURANCE_ITEM_BTN,
          index
        )}
        tooltip={t('Building.InsuranceDeleteBtnTooltipKey')}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        onClick={onRemove}
      />
    </Container>
  )
}

export default AccordionControlButtons
